import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { Injectable } from "@angular/core";
import { FiltroRicercaUnitaDocumentariaVO } from "../vo/filtro-ricerca-unita-documentariaVO";
import { MapperMetadatiProtocollo } from "./mapper-metadati-protocollo";
import { FiltroRicercaUnitaDocumentariaDTO } from "../dto/filtro-ricerca-unita-documentariaDTO";
import { MapperFascicolo } from "./mapper-fascicolo";
import { MapperClassifica } from "./mapper-classifica";
import { StatoUnitaDocumentariaEnum } from "../enum/stato-unita-documentaria-enum";
import { MapperSettore } from "./mapper-settore";
import { MapperTempiConservazione } from "./mapper-tempi-conservazione";
import { MapperTipologiaDocumento } from "./mapper-tipologia-documento";

@Injectable({
  providedIn: "root",
})
export class MapperFiltroRicercaUnitaDocumentaria
  implements
  MapperInterface<
    FiltroRicercaUnitaDocumentariaDTO,
    FiltroRicercaUnitaDocumentariaVO
  > {
  constructor(
    private mapperMetadatiProtocollo: MapperMetadatiProtocollo,
    private mapperFascicolo: MapperFascicolo,
    private mapperClassifica: MapperClassifica,
    private mapperSettore: MapperSettore,
    private mapperTempiConservazione: MapperTempiConservazione,
    private mapperTipologiaDocumento: MapperTipologiaDocumento
  ) { }
  convertDtoToVo(
    t: FiltroRicercaUnitaDocumentariaDTO
  ): FiltroRicercaUnitaDocumentariaVO {
    throw new Error("Method not implemented.");
  }
  convertListDtoToVo(
    t: FiltroRicercaUnitaDocumentariaDTO[]
  ): FiltroRicercaUnitaDocumentariaVO[] {
    throw new Error("Method not implemented.");
  }

  convertVoToDto(
    vo: FiltroRicercaUnitaDocumentariaVO
  ): FiltroRicercaUnitaDocumentariaDTO {
    if (vo != null) {
      const dto = new FiltroRicercaUnitaDocumentariaDTO();
      dto.oggetto = vo.oggetto;
      dto.fascicoloAppartenenza = this.mapperFascicolo.convertVoToDto(
        vo.fascicoloAppartenenza
      );
      dto.voceClassifica = this.mapperClassifica.convertVoToDto(
        vo.voceClassifica
      );
      dto.dataProtocolloDal = vo.dataProtocolloDal;
      dto.dataProtocolloAl = vo.dataProtocolloAl;
      dto.codiceClassificazione = vo.codiceClassificazione;
      dto.codiceStrutturaCmu = vo.codiceStrutturaCmu;
      dto.statoDaEscludere = vo.statoDaEscludere;
      dto.idRepository = vo.idRepository;
      dto.hash = vo.hash;
      dto.metadatiProtocollo = this.mapperMetadatiProtocollo.convertVoToDto(
        vo.metadatiProtocollo
      );
      dto.tipo = vo.tipo;
      dto.tipologiaDocumento = this.mapperTipologiaDocumento.convertVoToDto(
        vo.tipologiaDocumento
      );
      dto.limitazioniVisibilitaUtente = vo.limitazioniVisibilitaUtente;
      dto.ricercaSemplice = vo.ricercaSemplice;
      dto.strutturaResponsabile = this.mapperSettore.convertVoToDto(
        vo.strutturaResponsabile
      );
      dto.tempiConservazione = this.mapperTempiConservazione.convertVoToDto(
        vo.tempiConservazione
      );
      dto.numeroRepertorio = vo.numeroRepertorio;
      dto.dataAnniRepertoriazioneDal = vo.dataAnniRepertoriazioneDal;
      dto.dataAnniRepertoriazioneAl = vo.dataAnniRepertoriazioneAl;
      dto.campiSpecifici = vo.campiSpecifici;
      dto.nomeFile = vo.nomeFile;
      dto.descrizioneFile = vo.descrizioneFile;
      dto.firmatario = vo.firmatario;
      dto.dataManuale = vo.dataManuale;
      dto.collocazioneFisica = vo.collocazioneFisica;
      dto.originale = vo.originale;
      dto.inseritoDa = vo.inseritoDa;
      dto.inseritoDaCf = vo.inseritoDaCf;
      if (vo.stato) {
        switch (vo.stato) {
          case "IN LAVORAZIONE":
            dto.stato = StatoUnitaDocumentariaEnum.IN_LAVORAZIONE;
            break;
          case "IN BOZZA":
            dto.stato = StatoUnitaDocumentariaEnum.IN_BOZZA;
            break;
          case "CHIUSO":
            dto.stato = StatoUnitaDocumentariaEnum.CHIUSO;
            break;
          case "ANNULLATO":
            dto.stato = StatoUnitaDocumentariaEnum.ANNULLATO;
            break;
          case "ARCHIVIATO":
            dto.stato = StatoUnitaDocumentariaEnum.ARCHIVIATO;
            break;
          case "BLOCCATO":
            dto.stato = StatoUnitaDocumentariaEnum.BLOCCATO;
            break;
        }
      }

      return dto;
    } else {
      return null;
    }
  }

  convertListVoToDto(
    voList: FiltroRicercaUnitaDocumentariaVO[]
  ): FiltroRicercaUnitaDocumentariaDTO[] {
    if (voList != null) {
      return voList.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }
}
